<div class="d-flex align-items-center justify-content-center vh-100">
  <div class="bg-bg-3 w-50">
    <div class="container">
      <div class="p-16 bg-bg-2 justify-content-center">
        <div class="mb-8 fw-bold fs-4 text-primary text-center"><img src="/assets/static/images/finreg-logo.svg" alt="" class="img-fluid"></div>

        <form [formGroup]="form" class="mb-3 mt-3 needs-validation">
          <p class="mb-8 text-center">{{ 'pages.signup.question' | translate }}</p>
          <div class="row g-3">
            <div class="col-sm-6">
              <label class="form-label text-muted" for="firstName">{{'pages.signup.first_name' | translate }}</label>
              <input class="form-control" id="firstName" placeholder="" required type="text" value="">
              <div class="invalid-feedback">
                Valid first name is required.
              </div>
            </div>

            <div class="col-sm-6">
              <label class="form-label text-muted" for="lastName">{{'pages.signup.last_name' | translate }}</label>
              <input class="form-control" id="lastName" placeholder="" required type="text" value="">
              <div class="invalid-feedback">
                Valid last name is required.
              </div>
            </div>

            <div class="col-12">
              <label class="form-label text-muted" for="username">{{'pages.signup.username' | translate }}</label>
              <div class="input-group has-validation">
                <span class="input-group-text">&#64;</span>
                <input class="form-control" id="username" placeholder="name@example.com" required type="text">
                <div class="invalid-feedback">
                  Your username is required.
                </div>
              </div>
            </div>

            <div class="col-12">
              <label class="form-label" for="address">{{'pages.signup.address' | translate }}</label>
              <input class="form-control" id="address" [placeholder]="'pages.signup.address_hint' | translate" required type="text">
              <div class="invalid-feedback">
                Please enter your address.
              </div>
            </div>

            <div class="col-12">
              <label class="form-label" for="address2">{{'pages.signup.address' | translate }} 2 <span
                class="text-body-secondary">({{'pages.signup.optional' | translate }})</span></label>
              <input class="form-control" id="address2" [placeholder]="'pages.signup.address_hint2' | translate" type="text">
            </div>

            <div class="col-md-5">
              <label class="form-label text-muted" for="country">{{'pages.signup.country' | translate }}</label>
              <select class="form-select" id="country" required>
                <option value="">{{'pages.signup.choose_country' | translate }}</option>
                <option>Belgium</option>
                <option>Luxembourg</option>
                <option>Netherlands</option>
                <option>France</option>
                <option>Germany</option>
                <option>United States</option>
                <option>Russia</option>
                <option>Moldova</option>
              </select>
              <div class="invalid-feedback">
                Please select a valid country.
              </div>
            </div>

            <div class="col-md-4">
              <label class="form-label 1text-muted" for="city">{{'pages.signup.city' | translate }}</label>
              <input class="form-control" id="city" placeholder="" required type="text">
              <div class="invalid-feedback">
                City required.
              </div>
            </div>

            <div class="col-md-3">
              <label class="form-label text-muted" for="zip">{{'pages.signup.zip' | translate }}</label>
              <input class="form-control" id="zip" placeholder="" required type="text">
              <div class="invalid-feedback">
                Zip code required.
              </div>
            </div>
          </div>

          <!--hr class="my-4"-->

          <div class="form-check mt-4 mb-2">
            <input class="form-check-input" id="same-address" type="checkbox">
            <label class="form-check-label" for="same-address">{{'pages.signup.agree_terms' | translate }}</label>
          </div>

          <div class="form-check mb-5">
            <input class="form-check-input" id="save-info" type="checkbox">
            <label class="form-check-label" for="save-info">{{'pages.signup.notifications' | translate }}</label>
          </div>

          <!--hr class="my-4"-->

          <div class="d-grid">
            <button class="btn btn-action-2 rounded-1 w-100" type="submit">Submit</button>
          </div>
        </form>

        <div class="mt-8 text-center">
          <small class="text-muted">Already have an account?</small>
          <br>
          <a href="#" class="text-action-2 fw-semibold text-decoration-none" routerLink="/signin">Login</a>
        </div>
      </div>
    </div>
  </div>
</div>
